import { Sidebar } from "@/components/Sidebar";
import { Topbar } from "@/components/Topbar";

export function StudentLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-background relative">
      {/* Subtle gradient ambience */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden -z-0">
        <div className="glow-orb glow-orb-teal w-[500px] h-[500px] -top-32 -right-32" />
        <div className="glow-orb glow-orb-navy w-[400px] h-[400px] bottom-0 -left-20" />
        <div className="noise-overlay" />
      </div>

      <div className="flex relative z-10">
        <div className="hidden lg:block w-64 shrink-0">
          <div className="sticky top-0 h-screen">
            <Sidebar role="student" />
          </div>
        </div>
        <main className="flex-1 min-w-0">
          <Topbar role="student" title={title} />
          <div className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export function AdminLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-background relative">
      <div className="pointer-events-none fixed inset-0 overflow-hidden -z-0">
        <div className="glow-orb glow-orb-teal w-[500px] h-[500px] -top-32 -right-32 opacity-25" />
        <div className="glow-orb glow-orb-navy w-[400px] h-[400px] bottom-0 -left-20 opacity-30" />
        <div className="noise-overlay" />
      </div>

      <div className="flex relative z-10">
        <div className="hidden lg:block w-64 shrink-0">
          <div className="sticky top-0 h-screen">
            <Sidebar role="admin" />
          </div>
        </div>
        <main className="flex-1 min-w-0">
          <Topbar role="admin" title={title} />
          <div className="px-4 sm:px-6 lg:px-8 py-6 sm:py-8 max-w-7xl">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
